console.log('%cBuilt by Not selling liquid', 'color:#000; font-weight:bold;');

window.updateCartCountDisplay = function(count) {
  var countVal = parseInt(count, 10) || 0;
  var cartBtns = document.querySelectorAll('.header-cart');
  cartBtns.forEach(function(btn) {
    if (countVal > 0) {
      btn.classList.add('has-items');
    } else {
      btn.classList.remove('has-items');
    }
  });

  var cartCounts = document.querySelectorAll('.cart-count');
  cartCounts.forEach(function(el) {
    if (countVal > 0) {
      el.innerHTML = countVal;
    } else {
      el.innerHTML = '';
    }
  });
};

function quickAddButton(){
  document.querySelectorAll('.variant-grid').forEach(function(sizeList){
    if (sizeList.dataset.quickAddInitialized) return;
    sizeList.dataset.quickAddInitialized = 'true';

    sizeList.addEventListener('click',function(e){
      e.preventDefault();
      if (sizeList.hasAttribute('disabled')) return;
      let variant_id = sizeList.dataset.id;
      let error_grid_outer = sizeList.closest('.snippet-product-card');
      let error_grid = error_grid_outer ? error_grid_outer.querySelector('.grid-error') : null;
      let formData = {
        'items': [{
          'id': variant_id,
          'quantity': 1
        }]
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 422) {
          if (error_grid) {
            error_grid.innerHTML = data.description;
            setTimeout(function () {
              error_grid.innerHTML = '';
            }, 2000);
          }
        } else {
          document.body.classList.remove('open-shop-look');
          if (typeof load_cart == 'function') {
            var isCartPage = window.location.pathname.includes('/cart') || document.querySelector('[data-cart-page-section]');
            load_cart().then(function () {
              if (!isCartPage && typeof showCartNotification == 'function') {
                showCartNotification(variant_id);
              } else if (isCartPage && typeof refreshCartPage == 'function') {
                refreshCartPage();
              }
            });
          } else {
            window.location.href = "/cart";
          }
        }
        const url = '/cart.js';
        fetch(url)
        .then((resp) => resp.json())
        .then(function(data) {
          var cart_count = data.item_count;
          if(cart_count>0){
            document.querySelector('.cart-count').innerHTML = cart_count;
          }else{
            document.querySelector('.cart-count').innerHTML = '';
          }
        })
        .catch(function(error) {
          console.log(error);
        });
      })
      .catch((error) => {
        console.error(error);
      });
    });
  });    
//     document.querySelectorAll('.quick-add').forEach(function(quickAdd){
//       quickAdd.onclick = function(){
//         document.querySelectorAll('.snippet-product-grid').forEach(function(everyProduct){       
//           everyProduct.classList.remove('active-quick');
//         });
//         let gridimgbox = quickAdd.closest('.snippet-product-grid');      
//         gridimgbox.classList.add('active-quick');
//       };
//     });
}

if(document.querySelectorAll('.variant-grid').length){
  quickAddButton();
}
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    // Search is handled by the global "Search Drawer" section. Stay inert when its container is absent.
    if (!this.input || !this.predictiveSearchResults) return;
    this.input.addEventListener('focus', () => {
        document.body.classList.add('open-suggetion');
    });
    this.input.addEventListener('blur', () => {
        document.body.classList.remove('open-suggetion');
    })
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        const searchTerm = this.input.value.trim();
        if (searchTerm.length > 0) {
          const form = this.querySelector('form');
          if (form) form.submit();
        } else {
          event.preventDefault();
        }
      }
    });
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      }
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(typeof initProductCardSliders == 'function'){
        initProductCardSliders();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    this.predictiveSearchResults.style.display = 'block';
    document.querySelector('.search-suggetion').style.display = "none";
}
close() {
    this.predictiveSearchResults.style.display = 'none';
    document.querySelector('.search-suggetion').style.display = "block";
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);

document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter');
    document.querySelector(".mobile-serachbox #Search").focus();
  });
});

/* Product card image slider: hover slides to the 2nd image, arrows navigate. */
function initProductCardSliders(){
  if(typeof Splide === 'undefined') return;
  document.querySelectorAll('.pc-splide').forEach(function(el){
    if(el.classList.contains('is-initialized')) return;

    var root = el.closest('.grid-imagebox') || el;
    var prev = el.querySelector('.pc-arrow--prev');
    var next = el.querySelector('.pc-arrow--next');
    var bar  = el.querySelector('.pc-progress__bar');

    var sp = new Splide(el, {
      type      : 'slide',
      perPage   : 1,
      perMove   : 1,
      pagination: false,
      arrows    : false, // custom arrows
      drag      : true,
      speed     : 400
    });

    function syncArrows(){
      var end = sp.Components.Controller.getEnd ? sp.Components.Controller.getEnd() : (sp.length - 1);
      if(prev) prev.disabled = sp.index <= 0;
      if(next) next.disabled = sp.index >= end;
      if(bar){
        var total = sp.length || 1;
        bar.style.width = (((sp.index + 1) / total) * 100) + '%';
      }
    }

    sp.on('mounted moved updated', syncArrows);
    sp.mount();

    if(prev) prev.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); sp.go('<'); });
    if(next) next.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); sp.go('>'); });

    // Hover -> 2nd slide, leave -> back to 1st (pointer devices only)
    if(window.matchMedia && window.matchMedia('(hover: hover)').matches){
      root.addEventListener('mouseenter', function(){ sp.go(1); });
      root.addEventListener('mouseleave', function(){ sp.go(0); });
    }
  });
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', initProductCardSliders);
}else{
  initProductCardSliders();
}


document.addEventListener('click', function (e) {
  const qtySelector = e.target.closest('.cart-item__quantity');
  if (!qtySelector) return;
  const input = qtySelector.querySelector('input[type="number"]');
  let value = parseInt(input.value, 10) || 1;
  if (e.target.classList.contains('qty-plus')) {
    input.value = value + 1;
  }
  if (e.target.classList.contains('qty-minus')) {
    const min = parseInt(input.getAttribute('min'), 10) || 1;
    input.value = Math.max(min, value - 1);
  } 
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

// ===== WISHLIST STATE MANAGEMENT =====
(function () {
  const WISHLIST_KEY = 'ns_wishlist_data';

  window.getWishlistItems = function () {
    try {
      const dataStr = localStorage.getItem(WISHLIST_KEY);
      if (!dataStr) return [];
      const parsed = JSON.parse(dataStr);
      return parsed?.data?.wishlists?.[0]?.wishlists || [];
    } catch (e) {
      console.error('Error reading wishlist from localStorage:', e);
      return [];
    }
  };

  window.setWishlistItems = function (items) {
    try {
      const structure = {
        "data": {
          "wishlists": [
            {
              "wishlists": items
            }
          ]
        }
      };
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(structure));
      window.updateWishlistUI();
      // Dispatch custom event for dynamic updates on wishlist page
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items } }));
    } catch (e) {
      console.error('Error saving wishlist to localStorage:', e);
    }
  };

  window.toggleWishlistItem = function (item) {
    let items = window.getWishlistItems();
    const index = items.findIndex(it => String(it.handle) === String(item.handle));
    if (index > -1) {
      // Remove it
      items.splice(index, 1);
      window.setWishlistItems(items);
    } else {
      // Add it
      items.push({
        product_id: String(item.product_id),
        variant_id: String(item.variant_id),
        handle: String(item.handle)
      });
      window.setWishlistItems(items);
    }
  };

  window.updateWishlistUI = function () {
    const items = window.getWishlistItems();
    const handles = items.map(it => String(it.handle));

    // Toggle active class on all wishlist buttons
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const handle = btn.getAttribute('data-handle');
      if (handle && handles.includes(String(handle))) {
        btn.classList.add('active');
        btn.setAttribute('data-wishlist-added', 'true');
      } else {
        btn.classList.remove('active');
        btn.removeAttribute('data-wishlist-added');
      }
    });

    // Update global wishlist counters if present
    document.querySelectorAll('.wishlist-count').forEach(el => {
      el.textContent = items.length;
    });
  };

  // Bind click listeners on document load
  function initWishlistListeners() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.wishlist-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      const handle = btn.getAttribute('data-handle');
      const productId = btn.getAttribute('data-product-id');
      const variantId = btn.getAttribute('data-variant-id');

      if (!handle) return;

      window.toggleWishlistItem({
        product_id: productId || '',
        variant_id: variantId || '',
        handle: handle
      });
    });

    // Initial UI update
    window.updateWishlistUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistListeners);
  } else {
    initWishlistListeners();
  }

  // Hook for when new sections are dynamically loaded (e.g. Quick Buy popup)
  document.addEventListener('shopify:section:load', function () {
    window.updateWishlistUI();
  });

  // Also hook into custom quick buy open using MutationObserver
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.target.classList.contains('active')) {
        window.updateWishlistUI();
      }
    });
  });
  const quickBuyPopup = document.querySelector('.snippet-quick-buy-popup');
  if (quickBuyPopup) {
    observer.observe(quickBuyPopup, { attributes: true, attributeFilter: ['class'] });
  }
})();